/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Stats_Assetstooltip1Inputs */

const id_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset adalah file game`)
};

const ms_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aset ialah fail permainan`)
};

const da_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Et asset er spilfilerne`)
};

const de_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Asset sind die Spieldateien`)
};

const en_us2_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An asset is the game files`)
};

const es_es2_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un asset son los archivos del juego`)
};

const es_mx2_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un asset son los archivos del juego`)
};

const fil_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang asset ay ang mga file ng laro`)
};

const fr_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un asset est l'ensemble des fichiers du jeu`)
};

const it_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un asset sono i file di gioco`)
};

const hu_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az asset a játék fájljai`)
};

const nl_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een asset zijn de gamebestanden`)
};

const no_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En eiendel er spillfilene`)
};

const pl_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset to pliki gry`)
};

const pt_br2_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets tooltip`)
};

const pt_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um asset são os ficheiros do jogo`)
};

const ro_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un asset sunt fișierele jocului`)
};

const fi_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resurssi on pelin tiedostoja`)
};

const sv_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En tillgång är spelfilerna`)
};

const vi_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Một asset là tệp game`)
};

const tr_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset, oyun dosyalarıdır`)
};

const cs_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset jsou herní soubory`)
};

const bg_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активът са файловете на играта`)
};

const ru_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ассет — это файлы игры`)
};

const uk_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset — це ігрові файли`)
};

const ar_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأصل هو ملفات اللعبة`)
};

const hi_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एसेट गेम फ़ाइलें हैं`)
};

const th_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แอสเซทคือไฟล์เกม`)
};

const ja_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アセットはゲームファイルです`)
};

const zh_cn2_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets tooltip`)
};

const zh_hant1_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets tooltip`)
};

const ko_components_stats_assetstooltip1 = /** @type {(inputs: Components_Stats_Assetstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets tooltip`)
};

/**
* | output |
* | --- |
* | "An asset is the game files" |
*
* @param {Components_Stats_Assetstooltip1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_stats_assetstooltip1 = /** @type {((inputs?: Components_Stats_Assetstooltip1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Stats_Assetstooltip1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_stats_assetstooltip1(inputs)
	if (locale === "ms") return ms_components_stats_assetstooltip1(inputs)
	if (locale === "da") return da_components_stats_assetstooltip1(inputs)
	if (locale === "de") return de_components_stats_assetstooltip1(inputs)
	if (locale === "en-US") return en_us2_components_stats_assetstooltip1(inputs)
	if (locale === "es-ES") return es_es2_components_stats_assetstooltip1(inputs)
	if (locale === "es-MX") return es_mx2_components_stats_assetstooltip1(inputs)
	if (locale === "fil") return fil_components_stats_assetstooltip1(inputs)
	if (locale === "fr") return fr_components_stats_assetstooltip1(inputs)
	if (locale === "it") return it_components_stats_assetstooltip1(inputs)
	if (locale === "hu") return hu_components_stats_assetstooltip1(inputs)
	if (locale === "nl") return nl_components_stats_assetstooltip1(inputs)
	if (locale === "no") return no_components_stats_assetstooltip1(inputs)
	if (locale === "pl") return pl_components_stats_assetstooltip1(inputs)
	if (locale === "pt-BR") return pt_br2_components_stats_assetstooltip1(inputs)
	if (locale === "pt") return pt_components_stats_assetstooltip1(inputs)
	if (locale === "ro") return ro_components_stats_assetstooltip1(inputs)
	if (locale === "fi") return fi_components_stats_assetstooltip1(inputs)
	if (locale === "sv") return sv_components_stats_assetstooltip1(inputs)
	if (locale === "vi") return vi_components_stats_assetstooltip1(inputs)
	if (locale === "tr") return tr_components_stats_assetstooltip1(inputs)
	if (locale === "cs") return cs_components_stats_assetstooltip1(inputs)
	if (locale === "bg") return bg_components_stats_assetstooltip1(inputs)
	if (locale === "ru") return ru_components_stats_assetstooltip1(inputs)
	if (locale === "uk") return uk_components_stats_assetstooltip1(inputs)
	if (locale === "ar") return ar_components_stats_assetstooltip1(inputs)
	if (locale === "hi") return hi_components_stats_assetstooltip1(inputs)
	if (locale === "th") return th_components_stats_assetstooltip1(inputs)
	if (locale === "ja") return ja_components_stats_assetstooltip1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_stats_assetstooltip1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_stats_assetstooltip1(inputs)
	return ko_components_stats_assetstooltip1(inputs)
});
export { components_stats_assetstooltip1 as "components.stats.assetsTooltip" }